import React from 'react';

import styles from './onboarding.module.css';
import { getLocale } from './locales';
import { useOnboarding } from './onboardingContext';

// ÐÑÐ»ÑÑÐ¸ÑÑÑÑÐ°Ñ ÑÐ¾ÑÐºÐ° Ð½Ð° ÐºÐ½Ð¾Ð¿ÐºÐµ, Ð´Ð¾ ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð½Ð¾Ð²Ð¸ÑÐ¾Ðº ÐµÑÑ Ð½Ðµ Ð´Ð¾ÑÑÐ».
//
// ÐÐ±Ð¾ÑÐ°ÑÐ¸Ð²Ð°ÐµÑ ÐºÐ½Ð¾Ð¿ÐºÑ: <Hotspot item="client"><Button /></Hotspot>. ÐÐ°Ðº ÑÐ¾Ð»ÑÐºÐ¾
// ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²ÑÑÑÐ¸Ð¹ Ð¿ÑÐ½ÐºÑ ÑÐµÐº-Ð»Ð¸ÑÑÐ° Ð·Ð°ÐºÑÑÑ â ÑÐ¾ÑÐºÐ° Ð¿ÑÐ¾Ð¿Ð°Ð´Ð°ÐµÑ Ð½Ð°Ð²ÑÐµÐ³Ð´Ð°, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ
// Ð¾Ð¿ÑÑÐ½Ð¾Ð¼Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð¾Ð½Ð° Ð½Ð° Ð³Ð»Ð°Ð·Ð° Ð½Ðµ Ð¿Ð¾Ð¿Ð°Ð´Ð°ÐµÑÑÑ.

const Hotspot = ({ item, hintKey, children }) => {
  const { checklistDone, checklistHidden } = useOnboarding();
  const locale = getLocale();

  // ÐÐµÐ· Ð¿ÑÐ½ÐºÑÐ° ÑÐµÐº-Ð»Ð¸ÑÑÐ° ÑÐ¾ÑÐºÐµ Ð½ÐµÐ¾ÑÐºÑÐ´Ð° ÑÐ·Ð½Ð°ÑÑ, ÑÑÐ¾ ÐµÑ Ð¿Ð¾ÑÐ° Ð³Ð°ÑÐ¸ÑÑ, â Ð·Ð½Ð°ÑÐ¸Ñ
  // Ð¾Ð½Ð° Ð·Ð´ÐµÑÑ Ð½Ðµ Ð½ÑÐ¶Ð½Ð° Ð²Ð¾Ð²ÑÐµ.
  const show = item && !checklistHidden && !checklistDone.includes(item);
  if (!show) return children;

  const hint = hintKey ? locale.hotspots[hintKey] : null;

  return (
    <span className={styles.hotspot} title={hint || undefined}>
      {children}
      <span className={styles.dot} data-testid="onboarding-hotspot" />
    </span>
  );
};

export default Hotspot;
